import { create } from 'zustand';

const ACCESS_KEY = 'attendance_accessToken';
const REFRESH_KEY = 'attendance_refreshToken';
const USER_KEY = 'attendance_user';

export interface AuthUser {
    _id: string;
    name: string;
    displayName?: string;
    email: string;
    avatar?: string;
}

interface AuthState {
    user: AuthUser | null;
    accessToken: string | null;
    refreshToken: string | null;
    setSession: (data: { user: AuthUser; accessToken: string; refreshToken: string }) => void;
    setTokens: (accessToken: string, refreshToken: string) => void;
    clear: () => void;
}

function loadUser(): AuthUser | null {
    try {
        const raw = localStorage.getItem(USER_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch { return null; }
}

export const useAuthStore = create<AuthState>((set) => ({
    user: loadUser(),
    accessToken: typeof window !== 'undefined' ? localStorage.getItem(ACCESS_KEY) : null,
    refreshToken: typeof window !== 'undefined' ? localStorage.getItem(REFRESH_KEY) : null,
    setSession: ({ user, accessToken, refreshToken }) => {
        try {
            localStorage.setItem(USER_KEY, JSON.stringify(user));
            localStorage.setItem(ACCESS_KEY, accessToken);
            localStorage.setItem(REFRESH_KEY, refreshToken);
        } catch {}
        set({ user, accessToken, refreshToken });
    },
    setTokens: (accessToken, refreshToken) => {
        try {
            localStorage.setItem(ACCESS_KEY, accessToken);
            localStorage.setItem(REFRESH_KEY, refreshToken);
        } catch {}
        set({ accessToken, refreshToken });
    },
    clear: () => {
        try {
            localStorage.removeItem(USER_KEY);
            localStorage.removeItem(ACCESS_KEY);
            localStorage.removeItem(REFRESH_KEY);
        } catch {}
        set({ user: null, accessToken: null, refreshToken: null });
    },
}));
